import { ClubMetaData, MemberAppClubKey } from "../../../../builder/meta-data";

const gymflowApple = {
  team: "7Q5BLG5MRF",
  apiKey: "49X4TS8589",
  apiKeyIssuer: "a295b55c-1589-462b-8352-2c22d7b8b579",
};

export const memberClubs: { [key in MemberAppClubKey]: ClubMetaData } = {
  gymflow: {
    key: "gymflow",
    appType: "member",
    displayName: "Gymflow",
    bundleName: { ios: "com.gymflow.member", android: "com.gymflow.member" },
    splash_background: "#000957",
    apple: {
      appTeam: gymflowApple.team,
      appId: "1631161012",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972334324022462271/tracks/production?tab=releases",
    clubBrandingColor: "#8746EC",
  },
  bendqueermovcollective: {
    key: "bendqueermovcollective",
    appType: "member",
    displayName: "BEND",
    bundleName: {
      ios: "com.bendqueermovcollective.member",
      android: "com.bendqueermovcollective.member",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6462688646",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    clubRoute: "bend/queer/collective",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4974024234846345856/tracks/production?tab=releases",
    hideBookedVsCapacity: true,
  },
  azure: {
    key: "azure",
    appType: "member",
    displayName: "Azure Fitness",
    bundleName: {
      ios: "com.gymflow.azure.member",
      android: "com.gymflow.azure.member",
    },
    splash_background: "#84b4d8",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6473837212",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    clubRoute: "azurefitness/azurefitness/santamonica",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4976443472439057297/tracks/production?tab=releases",
  },
  builtrx: {
    key: "builtrx",
    appType: "member",
    displayName: "BuiltRX",
    bundleName: {
      ios: "com.gymflow.builtrx.member",
      android: "com.gymflow.builtrx.member",
    },
    apple: {
      appTeam: gymflowApple.team,
      appId: "6471967059",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    splash_background: "#000000",
    clubRoute: "builtrx/builtrx/melroseave",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973160853400847676/tracks/production?tab=releases",
  },
  twentyfourfit: {
    key: "twentyfourfit",
    appType: "member",
    displayName: "24fit",
    bundleName: {
      ios: "com.gymflow.twentyfourfit.member",
      android: "com.gymflow.twentyfourfit.member",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6463201681",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    brand: "24fit",
    clubBrandingColor: "#DF0000",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972073092028364989/tracks/production?tab=releases",
  },
  rehabadvantage: {
    key: "rehabadvantage",
    appType: "member",
    displayName: "Rehab Advantage",
    bundleName: {
      ios: "com.gymflow.rehabadvantage.members",
      android: "com.gymflow.rehabadvantage.members",
    },
    splash_background: "#353132",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6454901668",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    clubRoute: "rehabadvantage/rehabadvantage/castlehill",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4976351688554002886/tracks/production?tab=releases",
  },
  gymlocation: {
    key: "gymlocation",
    appType: "member",
    displayName: "Gym Location",
    bundleName: {
      ios: "com.gymflow.gymlocation.members",
      android: "com.gymflow.gymlocation.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: "FYF8DZZ9VQ",
      appId: "6459475457",
      webcredentials_url: "app.gymflow.io",
      merchantIdentifier: "merchant.com.gymlocation",
    },
    brand: "gymlocation",
    clubBrandingColor: "#1c1c1c",
    googleLink:
      "https://play.google.com/console/u/1/developers/6742220063837485596/app/4972228743588742129/tracks/production?tab=releases",
  },
  hybridfitness: {
    key: "hybridfitness",
    appType: "member",
    displayName: "Hybrid Fitness",
    bundleName: {
      ios: "com.gymflow.hybridfitness.members",
      android: "com.gymflow.hybridfitness.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6459450644",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    brand: "hybridfitness",
    clubBrandingColor: "#c01319",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972054487047498654/tracks/production?tab=releases",
  },
  pureperformance: {
    key: "pureperformance",
    appType: "member",
    displayName: "Pure Performance",
    bundleName: {
      ios: "com.gymflow.pureperformance.members",
      android: "com.gymflow.pureperformance.members",
    },
    splash_background: "#1adecf",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6459475315",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    clubRoute: "pureperformance/pureperformance/wanaka",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4975487802987874360/tracks/production?tab=releases",
  },
  regenlondon: {
    key: "regenlondon",
    appType: "member",
    displayName: "Regen London",
    // This bundle name seems wrong but it's actually right, this is a legacy name, the club changed branding but wanted to keep users with the same app
    // This shouldn't affect anything since .bundleName is used everywhere the bundle is needed automatically
    bundleName: {
      ios: "com.gymflow.treedfitness.members",
      android: "com.gymflow.treedfitness.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6448984525",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    brand: "regenlondon",
    clubBrandingColor: "#8e4fe4",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973490278312343322/tracks/production?tab=releases",
  },
  iamfittraining: {
    key: "iamfittraining",
    appType: "member",
    displayName: "iamFIT",
    bundleName: {
      ios: "com.gymflow.iamfittraining.members",
      android: "com.gymflow.iamfittraining.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6450174555",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    clubRoute: "iamfittraining/iamfittraining/Perth",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972872019896500877/tracks/production?tab=releases",
  },
  elysianstrength: {
    key: "elysianstrength",
    appType: "member",
    displayName: "Elysian Strength",
    bundleName: {
      ios: "com.gymflow.elysianstrength.members",
      android: "com.gymflow.elysianstrength.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6448121375",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    clubRoute: "elysianstrength/elysianstrength/elysianstrength",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4974679820539556217/tracks/production?tab=releases",
  },
  eurocity: {
    key: "eurocity",
    appType: "member",
    displayName: "Euro City Gym",
    bundleName: {
      ios: "com.gymflow.eurocity.members",
      android: "com.gymflow.eurocity.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: "QZ58S67Q5B",
      appId: "1659833596",
      webcredentials_url: "app.gymflow.io",
      merchantIdentifier: "merchant.com.eurocity",
    },
    clubRoute: "eurocity/eurocity/gibraltar",
    initialTab: "profile",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973765706950335387/tracks/production?tab=releases",
  },
  theprojectpt: {
    key: "theprojectpt",
    appType: "member",
    displayName: "The Project PT",
    bundleName: {
      ios: "com.gymflow.theprojectpt.members",
      android: "com.gymflow.theprojectpt.members",
    },
    splash_background: "#241d5a",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6444494870",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    brand: "theprojectpt",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4974692910504198413/tracks/production?tab=releases",
    clubBrandingColor: "#29235C",
  },
  goldexfitness: {
    key: "goldexfitness",
    appType: "member",
    displayName: "Goldex Fitness Plus",
    bundleName: {
      ios: "com.gymflow.goldexfitness.members",
      android: "com.gymflow.goldexfitness.members",
    },
    splash_background: "#100d0b",
    apple: {
      appTeam: "5Z4M4V3DC9",
      appId: "6449036590",
      webcredentials_url: "app.gymflow.io",
      merchantIdentifier: "merchant.com.goldexfitness",
    },
    brand: "goldexfitness",
    clubBrandingColor: "#ffce0a",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972328696327169186/tracks/production?tab=releases",
  },
  trainingaspects: {
    key: "trainingaspects",
    appType: "member",
    displayName: "Training Aspects",
    bundleName: {
      ios: "com.gymflow.trainingaspects.members",
      android: "com.gymflow.trainingaspects.members",
    },
    splash_background: "#010206",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6448995002",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    brand: "trainingaspects",
    clubBrandingColor: "#f8be00",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4974163477584959384/tracks/production?tab=releases",
  },
  spartanstrengthsystems: {
    key: "spartanstrengthsystems",
    appType: "member",
    displayName: "Spartan&#x2007;Strength",
    bundleName: {
      ios: "com.gymflow.spartanstrengthsystems.members",
      android: "com.gymflow.spartanstrengthsystems.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "1667882495",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    clubRoute: "spartanstrengthsystems/spartanstrengthsystems/colorado",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4974796804717290684/tracks/production?tab=releases",
  },
  fitnessadvantage: {
    key: "fitnessadvantage",
    appType: "member",
    displayName: "Fitness Advantage",
    bundleName: {
      ios: "com.gymflow.fitnessadvantage.members",
      android: "com.gymflow.fitnessadvantage.members",
    },
    splash_background: "#f3f3f3",
    apple: {
      appTeam: gymflowApple.team,
      appId: "1670113767",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    initialTab: "profile",
    clubRoute: "fitnessadvantage/fitnessadvantage/southold",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4974982963272713105/tracks/production?tab=releases",
  },
  myfitpod: {
    key: "myfitpod",
    appType: "member",
    displayName: "My Fit Pod",
    bundleName: {
      ios: "com.gymflow.myfitpod.members",
      android: "com.gymflow.myfitpod.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "1670143244",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    brand: "myfitpod",
    clubBrandingColor: "#000000",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972744243991089909/tracks/production?tab=releases",
  },
  lagunahealth: {
    key: "lagunahealth",
    appType: "member",
    displayName: "Laguna Health",
    bundleName: {
      ios: "com.gymflow.lagunahealth.members",
      android: "com.gymflow.lagunahealth.members",
    },
    splash_background: "#2f3470",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6461418933",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    clubRoute: "lagunahealthclub/lagunahealthclub/laguna",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4974585139670750923/tracks/production?tab=releases",
  },
  traingym: {
    key: "traingym",
    appType: "member",
    displayName: "Train Gym",
    bundleName: {
      ios: "com.gymflow.traingym.members",
      android: "com.gymflow.traingym.members",
    },
    splash_background: "#11101f",
    apple: {
      appTeam: gymflowApple.team,
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
      appId: "6478772045",
    },
    clubRoute: "traingym/traingym/westkingsdown",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4974497406860986759/tracks/production?tab=releases",
  },
  prospectparkyoga: {
    key: "prospectparkyoga",
    appType: "member",
    displayName: "Prospect Yoga",
    bundleName: {
      ios: "com.gymflow.prospectparkyoga.members",
      android: "com.gymflow.prospectparkyoga.members",
    },
    splash_background: "#0d880a",
    apple: {
      appTeam: gymflowApple.team,
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
      appId: "6478959258",
    },
    clubRoute: "prospectparkyoga/prospectparkyoga/brooklyn",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972352882952062011/tracks/production?tab=releases",
  },
  qa: {
    key: "qa",
    appType: "member",
    displayName: "QA Gymflow",
    bundleName: {
      ios: "com.gymflow.qa.members",
      android: "com.gymflow.qa.members",
    },
    splash_background: "#000957",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6443878098",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "dev.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4975382329207195201/tracks/internal-testing",
    clubBrandingColor: "#8746EC",
    isInternalApp: true,
  },
  dev: {
    key: "dev",
    appType: "member",
    displayName: "Dev Gymflow",
    bundleName: {
      ios: "com.gymflowmobile",
      android: "com.gymflowmobile",
    },
    splash_background: "#000957",
    apple: {
      appTeam: gymflowApple.team,
      appId: "",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "dev.gymflow.io",
    },
    googleLink: "",
    clubBrandingColor: "#8746EC",
    isInternalApp: true,
  },
  cencal: {
    key: "cencal",
    appType: "member",
    displayName: "CenCal Barbell",
    bundleName: {
      ios: "com.gymflow.cencal.members",
      android: "com.gymflow.cencal.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6479413566",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    clubRoute: "cencalbarbell/cencalbarbell/fresno",
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4975561125855349633/tracks/production?tab=releases",
  },
  everydai: {
    key: "everydai",
    appType: "member",
    displayName: "Everydai",
    bundleName: {
      ios: "com.gymflow.everydai.members",
      android: "com.gymflow.everydai.members",
    },
    splash_background: "#303030",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6479768972",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4975734930560829580/tracks/production?tab=releases",
    clubRoute: "everydaiperformance/everydaiperformance/goldcoast",
  },
  barewellness: {
    key: "barewellness",
    appType: "member",
    displayName: "Bare Wellness",
    bundleName: {
      ios: "com.gymflow.barewellness.members",
      android: "com.gymflow.barewellness.members",
    },
    splash_background: "#c78b69",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6480927124",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972283166112016150/tracks/production?tab=releases",
    clubRoute: "barewellness/barewellness/mcallen",
  },
  boxup: {
    key: "boxup",
    appType: "member",
    displayName: "Boxup Gyms",
    bundleName: {
      ios: "com.gymflow.boxup.members",
      android: "com.gymflow.boxup.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6483254864",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4975656143815773152/tracks/production?tab=releases",
    clubRoute: "boxupgyms/boxupgyms/ilford",
  },
  fitnesslab: {
    key: "fitnesslab",
    appType: "member",
    displayName: "The Fitness Lab",
    bundleName: {
      ios: "com.gymflow.fitnesslab.members",
      android: "com.gymflow.fitnesslab.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6498925038",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4975308995203653705/tracks/production?tab=releases",
    clubRoute: "thefitnesslab/thefitnesslab/brighouse",
  },
  infinitepilates: {
    key: "infinitepilates",
    appType: "member",
    displayName: "Infinite Pilates",
    bundleName: {
      ios: "com.gymflow.infinitepilates.members",
      android: "com.gymflow.infinitepilates.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6499139361",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973560636479658104/tracks/production?tab=releases",
    clubRoute: "infinitepilates/infinitepilates/heaton",
  },
  highstreet: {
    key: "highstreet",
    appType: "member",
    displayName: "High Street",
    bundleName: {
      ios: "com.gymflow.highstreet.members",
      android: "com.gymflow.highstreetwales.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6499144155",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4974237346588055943/tracks/production?tab=releases",
    clubRoute: "highstreetfitness/highstreetfitness/pontypool",
  },
  semper: {
    key: "semper",
    appType: "member",
    displayName: "SemperFiT",
    bundleName: {
      ios: "com.gymflow.semper.members",
      android: "com.gymflow.semper.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6502643318",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973932798009411263/tracks/production?tab=releases",
    clubRoute: "semperfit/semperfit/spring",
  },
  soller: {
    key: "soller",
    appType: "member",
    displayName: "Força de Sóller",
    bundleName: {
      ios: "com.gymflow.soller.members",
      android: "com.gymflow.soller.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6502766513",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4976064766544568375/tracks/production?tab=releases",
    clubRoute: "forcadesoller/forcadesoller/soller",
    defaultLanguage: "es",
  },
  laramie: {
    key: "laramie",
    appType: "member",
    displayName: "Laramie Fitness",
    bundleName: {
      ios: "com.gymflow.laramie.members",
      android: "com.gymflow.laramie.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6502766384",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972788920230718578/tracks/production?tab=releases",
    clubRoute: "laramiefitness/laramiefitness/laramie",
  },
  fluxsports: {
    key: "fluxsports",
    appType: "member",
    displayName: "Flux Sports Performance",
    bundleName: {
      ios: "com.gymflow.fluxsports.members",
      android: "com.gymflow.fluxsports.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6502766559",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972164446380492477/tracks/production?tab=releases",
    clubRoute: "fluxsportsperformance/fluxsportsperformance/sandiego",
  },
  methodfitness: {
    key: "methodfitness",
    appType: "member",
    displayName: "Method Fitness",
    bundleName: {
      ios: "com.gymflow.methodfitness.members",
      android: "com.gymflow.methodfitness.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6504492637",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973255611806277236/tracks/production?tab=releases",
    clubRoute: "methodfitness/methodfitness/caldwell",
  },
  cannonbeach: {
    key: "cannonbeach",
    appType: "member",
    displayName: "Cannon Beach",
    bundleName: {
      ios: "com.gymflow.cannonbeach.members",
      android: "com.gymflow.cannonbeach.members",
    },
    splash_background: "#1c1c1a",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6504678898",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972625069759310835/tracks/production?tab=releases",
    clubRoute: "cannonbeachfitness/cannonbeachfitness/cannonbeach",
  },
  physiquepro: {
    key: "physiquepro",
    appType: "member",
    displayName: "PhysiquePro",
    bundleName: {
      ios: "com.gymflow.physiquepro.members",
      android: "com.gymflow.physiquepro.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6504822302",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973127022862281140/tracks/production?tab=releases",
    brand: "physiquepro",
    clubBrandingColor: "#000000",
  },
  studiolibre: {
    key: "studiolibre",
    appType: "member",
    displayName: "Studio Libre",
    bundleName: {
      ios: "com.gymflow.studiolibre.members",
      android: "com.gymflow.studiolibre.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6529548083",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4974642777353536922/tracks/production?tab=releases",
    clubRoute: "studiolibre/studiolibre/chelmsford",
  },
  fitnessquarter: {
    key: "fitnessquarter",
    appType: "member",
    displayName: "Fitness Quarter",
    bundleName: {
      ios: "com.gymflow.fitnessquarter.members",
      android: "com.gymflow.fitnessquarter.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6575378717",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4975433038566558905/tracks/production?tab=releases",
    clubRoute: "fitnessquarter/fitnessquarter/cardiff",
  },
  equilibriumgymfitness: {
    key: "equilibriumgymfitness",
    appType: "member",
    displayName: "Equilibrium",
    bundleName: {
      ios: "com.gymflow.equilibriumgymfitness.members",
      android: "com.gymflow.equilibriumgymfitness.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: "R58G6BJ8GW",
      appId: "6590622712",
      webcredentials_url: "app.gymflow.io",
      merchantIdentifier: "merchant.com.equilibriumgymfitness",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973556802670389368/tracks/production?tab=releases",
    brand: "equilibrium",
    clubBrandingColor: "#000000",
  },
  alignfitness: {
    key: "alignfitness",
    appType: "member",
    displayName: "Align Fitness",
    bundleName: {
      ios: "com.gymflow.alignfitness.members",
      android: "com.gymflow.alignfitness.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6590623797",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4972252007469441190/tracks/production?tab=releases",
    clubRoute: "alignfitness/alignfitness/ludlow",
  },
  brisbanehpc: {
    key: "brisbanehpc",
    appType: "member",
    displayName: "Brisbane HPC",
    bundleName: {
      ios: "com.gymflow.brisbanehpc.members",
      android: "com.gymflow.brisbanehpc.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6670789352",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973686929791766499/tracks/production?tab=releases",
    clubRoute: "brisbanehpc/brisbanehpc/brisbane",
  },
  dropwellness: {
    key: "dropwellness",
    appType: "member",
    displayName: "Drop Wellness",
    bundleName: {
      ios: "com.gymflow.dropwellness.members",
      android: "com.gymflow.dropwellness.members",
    },
    splash_background: "#3f3233",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6720749491",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4976070516372353031/tracks/production?tab=releases",
    clubRoute: "drop/drop/worksop",
  },
  pacificpinesgolf: {
    key: "pacificpinesgolf",
    appType: "member",
    displayName: "Pacific Pines",
    bundleName: {
      ios: "com.gymflow.pacificpinesgolf.members",
      android: "com.gymflow.pacificpinesgolf.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6720750926",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4975009325394711438/tracks/production?tab=releases",
    clubRoute: "pacificpinesgolf/pacificpinesgolf/beavertown",
    isGolfClub: true,
  },
  downtown2: {
    key: "downtown2",
    appType: "member",
    displayName: "Down Town",
    bundleName: {
      ios: "com.gymflow.downtown2.members",
      android: "com.gymflow.downtown2.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6737061539",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973159651490060379/tracks/production?tab=releases",
    clubRoute: "downtownfitness/downtownfitness/devenport",
  },
  thebase: {
    key: "thebase",
    appType: "member",
    displayName: "The Base",
    bundleName: {
      ios: "com.gymflow.thebase.members",
      android: "com.gymflow.thebase.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6737345225",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4975051352740345993/tracks/production?tab=releases",
    clubRoute: "thebase/thebase/derby",
  },
  stackedsocial: {
    key: "stackedsocial",
    appType: "member",
    displayName: "Stacked Social",
    bundleName: {
      ios: "com.gymflow.stackedsocial.members",
      android: "com.gymflow.stackedsocial.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6737918697",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973778723283282638/tracks/production?tab=releases",
    clubRoute: "stackedsocialclub/stackedsocialclub/chillicothe",
  },
  fitlab: {
    key: "fitlab",
    appType: "member",
    displayName: "FITLAB",
    bundleName: {
      ios: "com.gymflow.fitlab.members",
      android: "com.gymflow.fitlab.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6738390443",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4976113075032973109/tracks/production?tab=releases",
    brand: "fitlab",
    clubBrandingColor: "#9B9B9B",
  },
  pike: {
    key: "pike",
    appType: "member",
    displayName: "Pike Fitness",
    bundleName: {
      ios: "com.gymflow.pike.members",
      android: "com.gymflow.pike.members",
    },
    splash_background: "#1c588c",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6739496815",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4973187088802325976/tracks/production?tab=releases",
    clubRoute: "pikefitness/pikefitness/vallejo",
  },
  eden: {
    key: "eden",
    appType: "member",
    displayName: "Eden Fitness",
    bundleName: {
      ios: "com.gymflow.eden.members",
      android: "com.gymflow.eden.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6739497456",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4975258647485143188/tracks/production?tab=releases",
    clubRoute: "edenfitnessstudio/edenfitnessstudio/sanfrancisco",
  },
  wemove: {
    key: "wemove",
    appType: "member",
    displayName: "We Move",
    bundleName: {
      ios: "com.gymflow.wemove.members",
      android: "com.gymflow.wemove.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6739497965",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/1/developers/7804111005037300339/app/4976361929873540979/tracks/production?tab=releases",
    clubRoute: "wemovefitness/wemovefitness/newcasle",
  },
  nofomo: {
    key: "nofomo",
    appType: "member",
    displayName: "NOFOMO FIT",
    bundleName: {
      ios: "com.gymflow.nofomo.members",
      android: "com.gymflow.nofomo.members",
    },
    splash_background: "#FFFFFF",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6740813255",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4974327839158829536/tracks/production?tab=releases",
    clubRoute: "nomofo/nomofo/cairns",
  },
  legacyfit: {
    key: "legacyfit",
    appType: "member",
    displayName: "Legacy Fit",
    bundleName: {
      ios: "com.gymflow.legacyfit.members",
      android: "com.gymflow.legacyfit.members",
    },
    splash_background: "#092b61",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6740813823",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972518497393906403/tracks/production?tab=releases",
    clubRoute: "nextlevelfit/nextlevelfit/howland",
  },
  coloradoiron: {
    key: "coloradoiron",
    appType: "member",
    displayName: "Colorado Iron",
    bundleName: {
      ios: "com.gymflow.coloradoiron.members",
      android: "com.gymflow.coloradoiron.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6741422706",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975991769373290727/tracks/production?tab=releases",
    clubRoute: "irongym/irongym/coloradosprings",
  },
  fullspeedperformance: {
    key: "fullspeedperformance",
    appType: "member",
    displayName: "Full Speed",
    bundleName: {
      ios: "com.gymflow.fullspeedperformance.members",
      android: "com.gymflow.fullspeedperformance.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6743701900",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972665147927571445/tracks/production?tab=releases",
    clubRoute: "fullspeedperformance/fullspeedperformance/Mitcham",
  },
  thefacility: {
    key: "thefacility",
    appType: "member",
    displayName: "The Facility",
    bundleName: {
      ios: "com.gymflow.thefacility.members",
      android: "com.gymflow.thefacility.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6743704008",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975491509190455584/tracks/production?tab=releases",
    clubRoute: "thefacility/thefacility/ardmore",
  },
  theperformancecentre: {
    key: "theperformancecentre",
    appType: "member",
    displayName: "The Performance",
    bundleName: {
      ios: "com.gymflow.theperformancecentre.members",
      android: "com.gymflow.theperformancecentre.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6743853575",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975244923604046352/tracks/production?tab=releases",
    clubRoute: "theperfomancecentre/theperfomancecentre/chelmsford",
  },
  aoxfit: {
    key: "aoxfit",
    appType: "member",
    displayName: "AOXFIT",
    bundleName: {
      ios: "com.gymflow.aoxfit.members",
      android: "com.gymflow.aoxfit.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6744245972",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4974037520242652754/tracks/production?tab=releases",
    clubRoute: "aoxfit/aoxfit/auckland",
  },
  tjjs: {
    key: "tjjs",
    appType: "member",
    displayName: "TJJS",
    bundleName: {
      ios: "com.gymflow.tjjs.members",
      android: "com.gymflow.tjjs.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6744246613",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972446395601999272/tracks/production?tab=releases",
    clubRoute: "thejiujitsusanctuary/thejiujitsusanctuary/chelmsford",
  },
  tres: {
    key: "tres",
    appType: "member",
    displayName: "TRES",
    bundleName: {
      ios: "com.gymflow.tres.members",
      android: "com.gymflow.tres.members",
    },
    splash_background: "#6d1d3a",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6744248833",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4976445392976084347/tracks/production?tab=releases",
    clubRoute: "TRES/tres/mission",
  },
  cloudnine: {
    key: "cloudnine",
    appType: "member",
    displayName: "Cloud9",
    bundleName: {
      ios: "com.gymflow.cloudnine.members",
      android: "com.gymflow.cloudnine.members",
    },
    splash_background: "#736635",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6744323431",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975268795025883678/tracks/production?tab=releases",
    clubRoute: "cloud9/cloud9/tonbridge",
  },
  templechambers: {
    key: "templechambers",
    appType: "member",
    displayName: "Temple Chambers",
    bundleName: {
      ios: "com.gymflow.templechambers.members",
      android: "com.gymflow.templechambers.members",
    },
    splash_background: "#c1784d",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6744641033",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4973503324115130266/tracks/production?tab=releases",
    clubRoute: "templechambers/templechambers/london",
  },
  satori: {
    key: "satori",
    appType: "member",
    displayName: "Satori Health",
    bundleName: {
      ios: "com.gymflow.satori.members",
      android: "com.gymflow.satori.members",
    },
    splash_background: "#2e2e30",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6744641982",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4973715156100788567/tracks/production?tab=releases",
    clubRoute: "satoriwomenshealthclub/satoriwomenshealthclub/unley",
  },
  viepilates: {
    key: "viepilates",
    appType: "member",
    displayName: "Vie Pilates",
    bundleName: {
      ios: "com.gymflow.viepilates.members",
      android: "com.gymflow.viepilates.members",
    },
    splash_background: "#f4eee4",
    apple: {
      appTeam: "RV4UUZ696D",
      appId: "6744642674",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
      merchantIdentifier: "merchant.com.viepilates",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972349063330454596/tracks/production?tab=releases",
    clubRoute: "viepilates/viepilates/varsitylakes",
  },
  forgefitnessnewport: {
    key: "forgefitnessnewport",
    appType: "member",
    displayName: "Forge Fitness Newport",
    bundleName: {
      ios: "com.gymflow.forgefitnessnewport.members",
      android: "com.gymflow.forgefitnessnewport.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6744965250",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4973851094091466483/tracks/production?tab=releases",
    clubRoute: "forgefitness/forgefitness/newport",
  },
  woodysgym: {
    key: "woodysgym",
    appType: "member",
    displayName: "Woody’s Gym",
    bundleName: {
      ios: "com.gymflow.woodysgym.members",
      android: "com.gymflow.woodysgym.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6745006484",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4973874239766561977/tracks/production?tab=releases",
    clubRoute: "woodysgym/woodysgym/pearland",
  },
  reproom: {
    key: "reproom",
    appType: "member",
    displayName: "Rep Room",
    bundleName: {
      ios: "com.gymflow.reproom.members",
      android: "com.gymflow.reproom.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6745093273",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4974110467839180205/tracks/production?tab=releases",
    clubRoute: "reproom/reproom/craigavon",
  },
  zonethirtyone: {
    key: "zonethirtyone",
    appType: "member",
    displayName: "Zone31",
    bundleName: {
      ios: "com.gymflow.zonethirtyone.members",
      android: "com.gymflow.zonethirtyone.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6745173847",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972743084533222738/tracks/production?tab=releases",
    clubRoute: "zone31/zone31/lincoln",
  },
  uplifted: {
    key: "uplifted",
    appType: "member",
    displayName: "Uplifted",
    bundleName: {
      ios: "com.gymflow.uplifted.members",
      android: "com.gymflow.uplifted.members",
    },
    splash_background: "#26242c",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6745224652",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972902288198051537/tracks/production?tab=releases",
    clubRoute: "upliftedgym/upliftedgym/meridian",
  },
  ninereformer: {
    key: "ninereformer",
    appType: "member",
    displayName: "NINE REFORMER",
    bundleName: {
      ios: "com.gymflow.ninereformer.members",
      android: "com.gymflow.ninereformer.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6745340436",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4973432578357483178/tracks/production?tab=releases",
    clubRoute: "ninereformerpilates/ninereformerpilates/aylesbury",
  },
  gymstop: {
    key: "gymstop",
    appType: "member",
    displayName: "GymStop",
    bundleName: {
      ios: "com.gymflow.gymstop.members",
      android: "com.gymflow.gymstop.members",
    },
    splash_background: "#2d2d2d",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6745480688",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972129525293631952/tracks/production?tab=releases",
    clubRoute: "gymstop/gymstop/rollingmeadows",
  },
  hitballstudio: {
    key: "hitballstudio",
    appType: "member",
    displayName: "Hit Ball Studio",
    bundleName: {
      ios: "com.gymflow.hitballstudio.members",
      android: "com.gymflow.hitballstudio.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6745790386",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972683810627199794/tracks/production?tab=releases",
    clubRoute: "hitballstudio/hitballstudio/coalisland",
  },
  wolfpacktwentyfourhour: {
    key: "wolfpacktwentyfourhour",
    appType: "member",
    displayName: "Wolfpack 24 Hour Gym",
    bundleName: {
      ios: "com.gymflow.wolfpacktwentyfourhour.members",
      android: "com.gymflow.wolfpacktwentyfourhour.members",
    },
    splash_background: "#020202",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6745793260",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4974810504832386612/tracks/production?tab=releases",
    clubRoute: "wolfpack24hourgym/wolfpack24hourgym/larne",
  },
  houseofbrutal: {
    key: "houseofbrutal",
    appType: "member",
    displayName: "HOBP",
    bundleName: {
      ios: "com.gymflow.houseofbrutal.members",
      android: "com.gymflow.houseofbrutal.members",
    },
    splash_background: "#040404",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6746797747",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4976156541336362591/tracks/production?tab=releases",
    clubRoute: "houseofbrutalpower/houseofbrutalpower/santabarbara",
  },
  cornerstone: {
    key: "cornerstone",
    appType: "member",
    displayName: "Cornerstone",
    bundleName: {
      ios: "com.gymflow.cornerstone.members",
      android: "com.gymflow.cornerstone.members",
    },
    splash_background: "#7e222f",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6746938536",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972996481249091067/tracks/production?tab=releases",
    clubRoute:
      "thecornerstonefamilyfitness/thecornerstonefamilyfitness/picayune",
  },
  forgepilates: {
    key: "forgepilates",
    appType: "member",
    displayName: "Forge Pilates",
    bundleName: {
      ios: "com.gymflow.forgepilates.members",
      android: "com.gymflow.forgepilates.members",
    },
    splash_background: "#f1efec",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6747115467",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4974821924948658665/tracks/production?tab=releases",
    clubRoute: "forgepilates/forgepilates/norwich",
  },
  arenagyms: {
    key: "arenagyms",
    appType: "member",
    displayName: "ARENA GYMS",
    bundleName: {
      ios: "com.gymflow.arenagyms.members",
      android: "com.gymflow.arenagyms.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6747249535",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975527234502011303/tracks/production?tab=releases",
    brand: "arenastrengthandfitness",
    clubBrandingColor: "#D0021B",
  },
  golftrk: {
    key: "golftrk",
    appType: "member",
    displayName: "GolfTRK",
    bundleName: {
      ios: "com.gymflow.golftrk.members",
      android: "com.gymflow.golftrk.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6747666801",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4974615170408952460/tracks/production?tab=releases",
    brand: "golfTRK",
    clubBrandingColor: "#678074",
    isGolfClub: true,
  },
  soma: {
    key: "soma",
    appType: "member",
    displayName: "Soma",
    bundleName: {
      ios: "com.gymflow.soma.members",
      android: "com.gymflow.soma.members",
    },
    splash_background: "#212121",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6748305227",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4974079211774565279/tracks/production?tab=releases",
    clubRoute: "somaclub/somaclub/cheltenham",
  },
  saunachill: {
    key: "saunachill",
    appType: "member",
    displayName: "Sauna Chill",
    bundleName: {
      ios: "com.gymflow.saunachill.members",
      android: "com.gymflow.saunachill.members",
    },
    splash_background: "#0c111d",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6748306370",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972095238356664008/tracks/production?tab=releases",
    clubRoute: "saunachill/saunachill/foxboro",
  },
  thetoningground: {
    key: "thetoningground",
    appType: "member",
    displayName: "Toning Ground",
    bundleName: {
      ios: "com.gymflow.thetoningground.members",
      android: "com.gymflow.thetoningground.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6748540538",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4973535231963638632/tracks/production?tab=releases",
    clubRoute: "thetoningground/thetoningground/woodfordgreen",
  },
  thectrl: {
    key: "thectrl",
    appType: "member",
    displayName: "The CTRL",
    bundleName: {
      ios: "com.gymflow.thectrl.members",
      android: "com.gymflow.thectrl.members",
    },
    splash_background: "#f6f5f5",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6748647832",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4973498595055950115/tracks/production?tab=releases",
    clubRoute: "thectrl/thectrl/london",
  },
  coactive: {
    key: "coactive",
    appType: "member",
    displayName: "CoActive",
    bundleName: {
      ios: "com.gymflow.coactive.members",
      android: "com.gymflow.coactive.members",
    },
    splash_background: "#000000",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6748827133",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4973014996165160122/tracks/production?tab=releases",
    clubRoute: "coactivehealth/coactivehealth/chalfontstgiles",
  },
  vibereformer: {
    key: "vibereformer",
    appType: "member",
    displayName: "Vibe Wellness",
    bundleName: {
      ios: "com.gymflow.vibereformer.members",
      android: "com.gymflow.vibereformer.members",
    },
    splash_background: "#8f7761",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6748914096",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975761365108023112/tracks/production?tab=releases",
    clubRoute: "vibereformerstudio/vibereformerstudio/sheffield",
  },
  prpc: {
    key: "prpc",
    appType: "member",
    displayName: "PRPC",
    bundleName: {
      ios: "com.gymflow.prpc.members",
      android: "com.gymflow.prpc.members",
    },
    splash_background: "#f9fbfc",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6749858736",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972819143542157515/tracks/production?tab=releases",
    clubRoute: "prpc/prpc/perryton",
  },
  flexionfit: {
    key: "flexionfit",
    appType: "member",
    displayName: "Flexion Fitness",
    bundleName: {
      ios: "com.gymflow.flexionfit.members",
      android: "com.gymflow.flexionfit.members",
    },
    splash_background: "#010101",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6749858977",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4976210930094731026/tracks/production?tab=releases",
    clubRoute: "flexionfitness/flexionfitness/craigavon",
  },
  reformerpilatesstudio: {
    key: "reformerpilatesstudio",
    appType: "member",
    displayName: "Reformer Pilates",
    bundleName: {
      ios: "com.gymflow.reformerpilatesstudio.members",
      android: "com.gymflow.reformerpilatesstudio.members",
    },
    splash_background: "#f6f4f0",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6751233048",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4974468881645222484/tracks/production?tab=releases",
    clubRoute: "thereformerpilatestudio/thereformerpilatestudio/sheffield",
  },
  mdmfit: {
    key: "mdmfit",
    appType: "member",
    displayName: "MDM Fit",
    bundleName: {
      ios: "com.gymflow.mdmfit.members",
      android: "com.gymflow.mdmfit.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6752251557",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4974357604148389706/tracks/production?tab=releases",
    clubRoute: "mdmfit/mdmfit/whiteplains",
  },
  dedicated: {
    key: "dedicated",
    appType: "member",
    displayName: "Dedicated Gym",
    bundleName: {
      ios: "com.gymflow.dedicated.members",
      android: "com.gymflow.dedicated.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6752613095",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972169927126956002/tracks/production?tab=releases",
    clubRoute: "thededicatedgym/thededicatedgym/westsussex",
  },
  insideninegolf: {
    key: "insideninegolf",
    appType: "member",
    displayName: "Inside 9 Golf",
    bundleName: {
      ios: "com.gymflow.insideninegolf.members",
      android: "com.gymflow.insideninegolf.members",
    },
    splash_background: "#427638",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6752717649",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4976379242385337800/tracks/production?tab=releases",
    clubRoute: "insideninegolfclub/insideninegolfclub/boerne",
  },
  novogym: {
    key: "novogym",
    appType: "member",
    displayName: "Novo",
    bundleName: {
      ios: "com.gymflow.novogym.members",
      android: "com.gymflow.novogym.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6753079993",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975967702670632659/tracks/production?tab=releases",
    brand: "novogym",
    clubBrandingColor: "#FBBF24",
  },
  gymsalen: {
    key: "gymsalen",
    appType: "member",
    displayName: "Gymsalen",
    bundleName: {
      ios: "com.gymflow.gymsalen.members",
      android: "com.gymflow.gymsalen.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6753593638",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975550689827079262/tracks/production?tab=releases",
    clubRoute: "gymsalen/gymsalen/haugesund",
  },
  rivervalley: {
    key: "rivervalley",
    appType: "member",
    displayName: "RVF",
    bundleName: {
      ios: "com.gymflow.rivervalley.members",
      android: "com.gymflow.rivervalley.members",
    },
    splash_background: "#ffffff",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6753594435",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4972613751409529765/tracks/production?tab=releases",
    clubRoute: "rivervalleyfitness/rivervalleyfitness/fortsmith",
  },
  korastudio: {
    key: "korastudio",
    appType: "member",
    displayName: "Kōra Studio",
    bundleName: {
      ios: "com.gymflow.korastudio.members",
      android: "com.gymflow.korastudio2.members",
    },
    splash_background: "#292218",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6753866123",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink:
      "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975731051131516154/tracks/production?tab=releases",
    clubRoute: "korapilatescollective/korapilatescollective/christiesbeach",
  },
  bamfitness: {
    key: "bamfitness",
    appType: "member",
    displayName: "BAM Fitness",
    bundleName: {
      ios: "com.gymflow.bamfitness.members",
      android: "com.gymflow.bamfitness.members",
    },
    splash_background: "#1e1e1e",
    apple: {
      appTeam: gymflowApple.team,
      appId: "6754650925",
      apiKey: gymflowApple.apiKey,
      apiKeyIssuer: gymflowApple.apiKeyIssuer,
      webcredentials_url: "app.gymflow.io",
    },
    googleLink: "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975009109066598998/tracks/production?tab=releases",
    clubRoute: "bamfitness/bamfitness/dumont",
  },
  solofit: {
      key: "solofit",
      appType: "member",
      displayName: "SOLO FIT",
      bundleName: {
        ios: "com.gymflow.solofit.members",
        android: "com.gymflow.solofit.members",
      },
      splash_background: "#000000",
      apple: {
        appTeam: gymflowApple.team,
        appId: "6754761625",
        apiKey: gymflowApple.apiKey,
        apiKeyIssuer: gymflowApple.apiKeyIssuer,
        webcredentials_url: "app.gymflow.io",
      },
      googleLink: "https://play.google.com/console/u/0/developers/7804111005037300339/app/4975883526640755964/tracks/production?tab=releases",
      clubRoute: "solofit/solofit/hemelhempstead",
    },
  templateKey: {
    // do not remove this object neither edit the line above, it is used to generate new clubs on setup-new-app.ts
    key: "templateKey",
    appType: "member",
    displayName: "",
    bundleName: { ios: "", android: "" },
    splash_background: "",
    apple: {
      appTeam: "",
      appId: "",
      apiKey: "",
      apiKeyIssuer: "",
      webcredentials_url: "",
    },
    googleLink: "",
    clubRoute: "",
    isInternalApp: true,
  },
};

const seenAppIds = new Set();
let appleAppSiteAssociationApps = [];
for (const gym of Object.values(memberClubs)) {
  if (!gym.isInternalApp) {
    if (gym.apple.appId === "") {
      console.warn(`Missing apple.appId for ${gym.key}`);
    }
    if (seenAppIds.has(gym.apple.appId)) {
      console.error(`Duplicate app store link for: ${gym.key}`);
    }
    appleAppSiteAssociationApps.push(
      `"${gym.apple.appTeam}.${gym.bundleName.ios}"`,
    );
    seenAppIds.add(gym.apple.appId);
  }
}
const apple = [];
const google = [];
if (require.main === module) {
  for (const brandedApp of Object.values(memberClubs).sort((a) =>
    a.apple.appTeam !== gymflowApple.team ? 1 : -1,
  )) {
    if (!!brandedApp.isInternalApp) continue;
    google.push(`"${brandedApp.googleLink}"`);
    apple.push(
      `"https://appstoreconnect.apple.com/apps/${brandedApp.apple.appId}/distribution/ios/version/deliverable"`,
    );
  }
  console.info(
    `Play Store:\n[\n  ${google.join(",\n  ")}\n].forEach(link => { window.open(link, "_blank"); });\n\n`,
  );
  console.info(
    `App Store:\n[\n  ${apple.join(",\n  ")}\n].forEach(link => { window.open(link, "_blank"); });`,
  );
}
